export default {
  "brand": "USFans Spreadsheet",
  "nav.spreadsheet": "Spreadsheet",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.comparisons": "Comparisons",
  "nav.safety": "Safety",
  "nav.categories": "Categories",
  "nav.resources": "Resources",
  "nav.home": "Home",
  "nav.buyingGuide": "Shopping Guide",
  "lang.label": "Language",
  "cta.explore": "Explore USFans Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.viewAll": "View all guides",
  "cta.readMore": "Read Guide",
  "cta.visitStore": "Visit the store",
  "article.notFound": "Article not found",
  "article.backHome": "Back to Home",
  "article.faqTitle": "Frequently Asked Questions",
  "article.relatedTitle": "Related Guides",
  "article.ctaTitle": "Continue Your Research",
  "article.ctaText": "Explore more guides or visit the store to put your research to use.",
  "footer.about": "An independent resource hub for researching USFans Spreadsheet, guides, comparisons, shipping insights and safety tips.",
  "footer.guides": "Guides",
  "footer.company": "Company",
  "footer.resources": "Resources",
  "footer.legal": "Legal",
  "footer.rights": "All rights reserved.",
  "footer.disclaimer": "This website is an independent informational resource. Information can change over time. Always verify important details before making purchases or sharing personal information."
};